import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-ink px-5 py-16" data-id="element-232" data-mp="2sk41z76p1a4p">
      <div className="mx-auto max-w-2xl border-2 border-red-400 bg-ink-mid p-8 text-center sm:p-11" data-id="element-233" data-mp="369phg7lab77z">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-red-300" data-id="element-234" data-mp="31jhd04agu6rj">
          <Clock3Icon className="h-4 w-4" data-id="element-235" data-mp="3g7cadxzf4zay" /> Limited-time offer
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-236" data-mp="3b90zdjxe0ir5">
          The launch price ends in:
        </h2>
        <div className="my-9" data-id="element-237" data-mp="3p8a4nok21sgc">
          <CountdownTimer size="large" dark data-id="element-238" data-mp="3p6h48r01c4gs" />
        </div>
        <p className="font-semibold text-white" data-id="element-239" data-mp="3l8jenn2crgcv">
          After that, the price goes up and never comes back down.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-240" data-mp="1uwvej6n4tr02">
          <div className="h-3 overflow-hidden border border-red-400/50 bg-ink-deep" data-id="element-241" data-mp="1qtz2xzw0ev5m">
            <div className="h-full w-[72%] bg-red-500" data-id="element-242" data-mp="2su6d7b51gjwe" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-243" data-mp="2srtngbt1h58s">
            <span className="text-red-300" data-id="element-244" data-mp="32ruao8u145i9">
              Limited spots — offer for today only
            </span>
            <span className="text-slate-300" data-id="element-245" data-mp="37iapnxdhzz6q">72% claimed</span>
          </div>
        </div>
      </div>
    </section>;
}